import { IconName } from '../../components/icon';
/**
 * Alert State
 */
export var AlertState;
(function (AlertState) {
    AlertState["SUCCESS"] = "SUCCESS";
    AlertState["INFO"] = "INFO";
    AlertState["WARNING"] = "WARNING";
    AlertState["ERROR"] = "ERROR";
    /** @deprecated */
    AlertState["DANGER"] = "DANGER";
    /** @deprecated */
    AlertState["PRIMARY"] = "PRIMARY";
    /** @deprecated */
    AlertState["TERTIARY"] = "TERTIARY";
})(AlertState || (AlertState = {}));
/**
 * Returns alert's classname depending on alert type
 * @param alertType {string} - Alert type
 * @returns {string} - Alert value
 */
export const getAlertClassName = (alertType) => {
    switch (alertType) {
        case 'SUCCESS':
            return 'success';
        case 'INFO':
            return 'info';
        case 'WARNING':
            return 'warning';
        /** @deprecated */
        case 'DANGER':
            return 'danger';
        case 'ERROR':
            return 'error';
        case 'TERTIARY':
            return 'tertiary';
        case 'PRIMARY':
            return 'primary';
        default:
            return '';
    }
};
/**
 * Returns alert's style depending on alert type
 * @param alertType {string} - Alert type
 * @returns {string} - Alert value
 */
export const getAlertStyle = (alertType) => {
    switch (alertType) {
        case 'SUCCESS':
            return '#007B52';
        case 'INFO':
            return '#0C7B91';
        case 'WARNING':
            return '#FFBB33';
        case 'DANGER':
            return '#D42D02';
        case 'ERROR':
            return '#D42D02';
        case 'TERTIARY':
            return '#25465f';
        case 'PRIMARY':
            return '#CC4E0A';
        default:
            return '';
    }
};
/**
 * Returns alert's icon name depending on alert type
 * @param alertType {string} - Alert type
 * @returns {string} - Alert value
 */
export const getAlertIconName = (alertType) => {
    switch (alertType) {
        case 'SUCCESS':
            return IconName.CHECK_CIRCLE;
        case 'INFO':
            return IconName.INFOS_CIRCLE;
        case 'WARNING':
            return IconName.ALERT;
        case 'DANGER':
            return IconName.EXCLAMATION_CIRCLE;
        case 'ERROR':
            return IconName.EXCLAMATION_CIRCLE;
        default:
            return IconName.INFOS_CIRCLE;
    }
};
//# sourceMappingURL=Alert.js.map